function readClient() {
  return typeof window !== 'undefined' ? window.posthog ?? null : null;
}

/**
 * PostHog destination. register() holds session supers; capture() is track.
 * identify() here only updates person properties — super props go through register
 * so they attach to every later capture (same role as facade traits).
 *
 * @type {import('./index').AnalyticsDestination}
 */
export const posthogAdapter = {
  track(event, properties) {
    readClient()?.capture?.(event, properties);
  },

  identify(traits) {
    const client = readClient();
    if (!client) return;

    if (typeof client.register === 'function') {
      client.register(traits);
    }

    if (typeof client.setPersonProperties === 'function') {
      client.setPersonProperties(traits);
    }
  }
};
